import { useCallback, useState } from 'react';

export type Step = 'inactive' | 'modal' | 'spotlight' | 'flag' | 'finished';

export const useStep = () => {
	const [step, setStep] = useState<Step>('inactive');

	const start = useCallback(() => setStep('modal'), []);
	const finish = useCallback(() => setStep('finished'), []);

	const next = useCallback(
		() =>
			setStep((current) => {
				switch (current) {
					case 'inactive':
						return 'modal';
					case 'modal':
						return 'spotlight';
					case 'spotlight':
						return 'flag';
					case 'flag':
						return 'finished';
					default:
						return 'inactive';
				}
			}),
		[],
	);

	return [step, { next, start, finish }] as const;
};
